module.exports = __webpack_public_path__ + "img/speaker-4-2.c4538333.jpg";